// src/components/ui/icon/icons/CreatorIcon.tsx
import { jsx } from "react/jsx-runtime";
var CreatorIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.66678 4.66672L5.80011 1.80005C5.49903 1.50042 5.09155 1.33221 4.66678 1.33221C4.24201 1.33221 3.83453 1.50042 3.53345 1.80005L1.80011 3.53338C1.50048 3.83447 1.33228 4.24195 1.33228 4.66672C1.33228 5.09149 1.50048 5.49897 1.80011 5.80005L4.66678 8.66672M5.33358 4.00002L6.66691 2.66669M12.0002 10.6667L13.3336 9.33335M11.3336 7.33335L14.2002 10.2C14.8269 10.8267 14.8269 11.84 14.2002 12.4667L12.4669 14.2C11.8402 14.8267 10.8269 14.8267 10.2002 14.2L7.33358 11.3334M10.0002 3.33335L12.6669 6.00002M14.1162 4.54128C14.4687 4.1889 14.6667 3.71093 14.6668 3.21252C14.6669 2.71411 14.4689 2.23609 14.1165 1.88362C13.7641 1.53114 13.2862 1.33309 12.7878 1.33303C12.2894 1.33297 11.8113 1.5309 11.4589 1.88328L2.56153 10.7826C2.40675 10.9369 2.29228 11.127 2.2282 11.3359L1.34753 14.2373C1.3303 14.2949 1.329 14.3562 1.34377 14.4145C1.35853 14.4729 1.38881 14.5261 1.4314 14.5686C1.47398 14.6111 1.52728 14.6413 1.58564 14.656C1.644 14.6707 1.70524 14.6693 1.76287 14.6519L4.66487 13.7719C4.87365 13.7084 5.06365 13.5947 5.2182 13.4406L14.1162 4.54128Z",
        stroke: "currentColor",
        strokeWidth: "1.33",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var CreatorIcon_default = CreatorIcon;

export {
  CreatorIcon_default
};
//# sourceMappingURL=chunk-QBQ64CAM.js.map